/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, OnInit } from '@angular/core';
import { IonRouterOutlet, ModalController, NavController, Platform, ToastController } from '@ionic/angular';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { AlertController } from '@ionic/angular';
import { LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Md5 } from 'ts-md5';
import { Observable, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { LocationService } from '@shared/services/location.service';
import { Preferences } from '@capacitor/preferences';
import { UserService } from '@shared/services/user.service';
import { EmailValidationPage } from '../email-validation/email-validation.page';
import { UtilService } from '@shared/utils/util';
import { Capacitor } from '@capacitor/core';
import { OnboardingService } from '@shared/services/onboarding.service';
@Component({
  selector: 'app-signup-with-email',
  templateUrl: './signup-with-email.page.html',
  styleUrls: ['./signup-with-email.page.scss'],
  providers:[UserService, UtilService,IonRouterOutlet],
})
export class SignupWithEmailPage implements OnInit {
  @Input() referralUserId: string = '';
  public signupWithEmailForm = new FormGroup({
    emailControl: new FormControl('',  Validators.compose([Validators.maxLength(50), Validators.email, Validators.required])),
    userpassControl: new FormControl('',  Validators.compose([Validators.maxLength(15), Validators.required])),
    reenterpassControl: new FormControl('',  Validators.compose([Validators.maxLength(15), Validators.required]))
  });
  submitAttempt: boolean = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public userData: any = {}; 
  show: boolean = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public backButton: Subscription|any;
  isIosNative = false;
  constructor(
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    public loadingCtrl:LoadingController,
    private translate: TranslateService,
    private route: ActivatedRoute,
    public locationSvc: LocationService,
    public userService: UserService,
    public util: UtilService,
    public toastCtrl: ToastController,
    public navCtrl: NavController,
    public platform: Platform, 
    private router: Router,
    private onboardingService: OnboardingService,
  ) {
    this.isIosNative = Capacitor.isNativePlatform() && !this.platform.is('android');
  }

  ionViewWillEnter() {
    if(this.platform.is('android')) {
      this.backButton = this.platform.backButton.subscribe(() => {
        this.goBack();
      });
    }
  }

  ionViewWillLeave() {
    if(this.backButton){
      this.backButton.unsubscribe();
    }
  }
  
  ngOnInit() {
    const fromQuery = this.route.snapshot.queryParamMap.get('referralUserId');
    if (fromQuery) {
      this.referralUserId = fromQuery;
    }
    // Modal/router may omit query; still credit referrer from captured deep-link/UTM attribution.
    if (!this.referralUserId) {
      const fromAttribution = this.userService.getPendingAcquisitionAttribution()?.['referralUserId'];
      if (fromAttribution) {
        this.referralUserId = fromAttribution;
      }
    }
  }
  async goBack(){
    const top = await this.modalCtrl.getTop();
    if (top) {
      await this.modalCtrl.dismiss();
      return;
    }
    this.router.navigateByUrl('/login');
  }

  async continueWithSocial(provider: 'google' | 'facebook' | 'apple'): Promise<void> {
    const top = await this.modalCtrl.getTop();
    if (top) {
      await this.modalCtrl.dismiss({ social: provider });
      return;
    }
    // Web landing opens this page via router (not a modal).
    this.router.navigate(['/login'], { queryParams: { social: provider } });
  }

  async showModalAlert(message:string) {
    const alert = await this.alertCtrl.create({
      subHeader: message,
      buttons: [
        {
          text: 'OK',
          handler: () => { }
        }
      ]
    });

    await alert.present();
  }

  async showLoading(message:string) {
    const loading = await this.loadingCtrl.create({
      message: message,
      duration: 3000,
      // translucent: true,

      // backdropDismiss: true
    });

    loading.present();
  }

  async signMeUp(){
    this.submitAttempt = true;
    if(!this.signupWithEmailForm.valid){
      this.showModalAlert(this.translate.instant('fixHighlighted'));
    } 
    if(this.signupWithEmailForm.controls['userpassControl'].value != this.signupWithEmailForm.controls['reenterpassControl'].value){
      this.showModalAlert(this.translate.instant('passwordsDontMatch'));
      return;
    }
    if(this.signupWithEmailForm.valid) {
      this.showLoading(this.translate.instant('pleaseWait'));


      const loader = this.loadingCtrl.create({
        message: this.translate.instant('pleaseWait'),
        // duration:10000
      });
      (await loader).present();

      const encryptedPass = Md5.hashStr(String(this.signupWithEmailForm.value.userpassControl));
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      let theObs: Observable<any>;
      const browserLanguage = UtilService.normalizeLanguage(this.translate.getBrowserLang());

      await this.onboardingService.loadProgress();
      this.userData = this.onboardingService.applyCollectedData({
        referralUserId: this.referralUserId,
        email:String(this.signupWithEmailForm.controls['emailControl'].value),
        password:encryptedPass,
        needsEmailValidation:true,
        language: browserLanguage
      });

      Preferences.get({key:'LAST_LOCATION'}).then(async (val) => {
        val = val.value ? JSON.parse(val.value) : null;
        let location = val;
        const teleportationLocation = this.locationSvc.getTeleportationLocation();
        if(teleportationLocation != null){
          location = teleportationLocation;
        }

        // Retrieve and add FCM token to userData before sending to server
        const fcmToken = await Preferences.get({ key: 'TOKEN' });
        if (fcmToken && fcmToken.value) {
          this.userData.token = fcmToken.value;
        } else {
          const localToken = localStorage.getItem('TOKEN');
          if (localToken) {
            this.userData.token = localToken;
          }
        }

        theObs = this.userService.upsertSoul(this.userData, location, false, false, true);

        theObs.subscribe(async data => {
          console.log('upsert subscribe entered');
          console.log(JSON.stringify(data));
          if(data != '{not ok}'){
            this.userData = JSON.parse(data);
            Preferences.set({key:'USER_DATA',  value: JSON.stringify(this.userData)}).then(()=> {
              console.log('userdata saved to DB');
            });

            (await loader).dismiss();

            this.showWelcomeBackMsg(this.userData);

            const progress = this.onboardingService.getCurrentProgress()
              || await this.onboardingService.loadProgress();
            if (progress) {
              await this.onboardingService.trackSignup('email', this.userData);
              if (progress.variant === 'test') {
                await this.onboardingService.submitToServer('', 'email');
              }
              await this.onboardingService.clearProgress();
            }

            this.openEmailValidation();
            
          } else{
            (await loader).dismiss();
          }
        },
        async err => {
          console.log('Error: ' + JSON.stringify(err));
          (await loader).dismiss();
          this.util.showToastUnableToConnect(this.toastCtrl);
        }

        )
      })
      


    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showWelcomeBackMsg(userData: any){
    if(userData.wasOnHibernate != null){
      this.showModalAlert(this.translate.instant('welcomeBackFromHibernate'));
    }
  }

  private async openEmailValidation(){
    const modal = this.modalCtrl.create({
      component: EmailValidationPage, 
      componentProps: {
        referralUserId: this.referralUserId
      }

    });

    (await modal).onDidDismiss().then((val) => {
      if (val && val.data === "loggedIn") {
        this.continueAfterEmailValidation();
      }
    });

    

    (await modal).present();
  }

  private async continueAfterEmailValidation() {
    UtilService.loggedOut = false;
    UserService.loggedOut = false;
    localStorage.setItem('USER_LOGGED', 'true');
    await Preferences.set({ key: 'USER_LOGGED', value: 'true' });

    const top = await this.modalCtrl.getTop();
    if (top) {
      await this.modalCtrl.dismiss('loggedIn');
      return;
    }

    const destination = this.userData?.interest2 != null ? '/tabs/home' : '/tabs/my-profile-display';
    this.router.navigateByUrl(destination);
  }


  async alreadyHaveValCode(){


    Preferences.get({key:'USER_DATA'}).then(async val => {
      this.userData = val.value ? JSON.parse(val.value) : null;
      if(this.userData!= null){
        console.log('alreadyHaveValCode - Got some data from Storage: ' + JSON.stringify(val));
        if(this.userData.tempValidationCode != null){
          const modal = this.modalCtrl.create({component: EmailValidationPage});
          (await modal).onDidDismiss().then((dismissed) => {
            if (dismissed && dismissed.data === "loggedIn") {
              this.continueAfterEmailValidation();
            }
          });
          (await modal).present();
        } else {
          this.showModalAlert(this.translate.instant('validationCodeExpired'));
        }
      } else{
        this.showModalAlert(this.translate.instant('validationCodeExpired'));
      }
    })
  }

  password() {
    this.show = !this.show;
  }

}
